
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","version":"1.1","viewBox":"0 920 1920 130"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradient","x1":".68","y1":"77.68","x2":"1919.72","y2":"77.68","gradientTransform":"matrix(1 0 0 -1 0 1082.17)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fe676b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#fe676b"}})]),_c('linearGradient',{attrs:{"id":"linear-gradient1","x1":"-1040.25","y1":"1239.84","x2":"-925.74","y2":"1239.84","gradientTransform":"matrix(0 -1 -1 0 1262.39 -2.51)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#f8f146"}}),_c('stop',{attrs:{"offset":".23","stop-color":"#e9f370"}}),_c('stop',{attrs:{"offset":".73","stop-color":"#c7f8d6"}})]),_c('linearGradient',{attrs:{"id":"linear-gradient2","x1":"2697.19","y1":"866.18","x2":"2589.42","y2":"866.18","gradientTransform":"matrix(0 1 1 0 1021.46 -1617.19)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#f8f146"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#c6f8da"}})])]),_c('path',{attrs:{"fill":"url(#linear-gradient)","d":"M.68 928.98h1919.03v151.01H.68z"}}),_c('path',{attrs:{"fill":"url(#linear-gradient1)","d":"M0 923.23v114.51h22.54v-28.47h22.55v-86.04H0z"}}),_c('path',{attrs:{"fill":"url(#linear-gradient2)","d":"M1850.97 1080h73.33V972.23h-17.94l-.02 28.74H1888l-.11 29.21h-18.33l.11 28.91h-18.7V1080z"}})])
          )
        }
      }
    